import { Inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot } from '@angular/router';
import { ClaimService } from '../shared/claimservice';
import { catchError, map } from 'rxjs/operators';
import { of } from "rxjs";
import { SessionService } from "./sessionservice";
import { OKTA_AUTH } from "@okta/okta-angular";
import { OktaAuth } from "@okta/okta-auth-js";
import { LogService } from "./logservice";

@Injectable()
export class ClaimResolver {
  constructor(private claimService: ClaimService, 
                @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
                private sessionService:SessionService,
                private logService: LogService) {    

  }
  resolve(route: ActivatedRouteSnapshot) {
    if(this.sessionService.userOrg === '' || this.sessionService.userOrg === undefined)
      this.sessionService.userOrg = String(this.oktaAuth.authStateManager.getAuthState()?.idToken?.claims.orgval ?? '');    
    if(this.sessionService.userId === '' || this.sessionService.userId === undefined)
      this.sessionService.userId = this.oktaAuth.authStateManager.getAuthState()?.idToken?.claims.email ?? '';
    if(this.sessionService.idToken === '' || this.sessionService.idToken === undefined)
      this.sessionService.idToken = this.oktaAuth.authStateManager.getAuthState()?.idToken?.idToken;   
    const id = route.paramMap.get('id');
    return this.claimService.getClaim(id).pipe(map(result => result),
    catchError((error) => {      
      // Extract error message from various possible property paths
      const errorMessage = 
        error?.error?.errorMessage ||
        error?.error?.message ||
        error?.message ||
        error?.statusText ||
        (typeof error?.error === 'string' ? error.error : null) ||
        'Unable to retrieve claim information';
      
      const message = `Retrieval error: ${errorMessage}`;

      // Log the entire error object for debugging
      this.logService.logMessage(JSON.stringify(error));
      //console.error(error);
      return of({ error: message });
    }));
  }
}
